export const isMobileNumber = (phone: string) => {
    const regex = /^(06|36|0036|\+36)?(20|30|50|70)([0-9]{7})$/;
    let match = phone.replace(/\s/g, '').match(regex);
    return Boolean(match !== null && match.length > 0);
}
